<template>

  <v-sheet v-if="dense" class="labels-container" height="20">
    <template v-for="(label, i) in labelsMap">
      <v-tooltip :key="i" top>
        <template v-slot:activator="{on}">
          <div :class="['label-dot', {dark: isDark}]" v-on="on" :style="{backgroundColor: label.color}" />
        </template>
        <span>{{label.description}}</span>
      </v-tooltip>
    </template>
  </v-sheet>

  <v-chip-group v-else>
    <template v-for="(label, i) in labelsMap">
      <v-chip :class="['label', {dark: isDark, 'dark-text': label.isDark}]" label small  :key="i" :color="label.color">
        {{label.description}}
      </v-chip>
    </template>
  </v-chip-group>

</template>

<script>
import tinycolor from 'tinycolor2';
export default {
  name: "EventLabels",
  props: {
    labels: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    labelsMap(){
      const vm = this
      return vm.labels.map(label => ({
        ...label,
        isDark: tinycolor(label.color).isDark()
      }))
    }
  }
}
</script>

<style scoped>
  .labels-container{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 10px;
    padding-left: 5px;
    background-color: transparent !important;
    justify-content: flex-start;
    align-items: center;
  }

  .label{
    border: 1px solid #000 !important;
    color: #000 !important;
  }


  .label.dark-text{
    color: #fff !important;;
  }

  .label-dot{
    height: 15px;
    width: 15px;
    border-radius: 8px;
    margin: 1px;
    border: 1px solid #000;
  }

  .label.dark,
  .label-dot.dark{
    border: 1px solid #fff !important;
  }


</style>
